export const selectIsUserLoggedIn = (state) =>
  state.auth.loginStatus === "succeeded" && !!state.auth.authUser;
